/* ml-steel-scenes.js — the customer's steel piece placed into real room photos, in the browser.
 * window.mlSteelScenes(stencilUrl, name, cb, opts) → cb([{key, mount, label, src}]) once, all scenes.
 * Input = the engine's black-on-transparent stencil (/generate-metal `url`). Nothing is generated per
 * customer: the room photos (plates) are fixed theme assets; the piece, its name bar, the powder coat,
 * the shadows are painted here, so the cut outline is exactly what gets cut.
 * Geometry = metal_v2.py: art 295 mm wide, tyres bite 3 mm into a 20 mm bar (30 mm on the wall
 * piece), bar seats 3 mm into a 25 mm base that stands 15 mm proud each side. */
(function () {
  // Each plate: where the piece stands. cx = centre x, y = contact line (desk) or bottom of the
  // piece (wall), w = piece width incl. base, all in plate pixels (1024 square). lx/ly = light direction.
  var PLATES = [
    // 4 Nov (Nelson): close-up shots lead, piece ~78% of the frame; the bench and garage wall read too small and dark
    { key: 'desk-shelf', mount: 'desk', label: 'On the shelf', file: 'ml-steel-desk-shelf.jpg', cx: 515, y: 625, w: 800, lx: -1, warm: 0.06 },
    { key: 'wall-sofa', mount: 'wall', label: 'Above the sofa', file: 'ml-steel-wall-sofa.jpg', cx: 500, y: 735, w: 800, lx: 0.6, warm: 0.06 },
    { key: 'desk-office', mount: 'desk', label: 'In the office', file: 'ml-steel-desk-office.jpg', cx: 470, y: 700, w: 470, lx: -1, warm: 0.04 },
    { key: 'wall-den', mount: 'wall', label: 'In the den', file: 'ml-steel-wall-den.jpg', cx: 600, y: 640, w: 600, lx: -1, warm: 0.14 }
  ];
  var FONT = 'Barlow, "DIN Alternate", "Arial Narrow", sans-serif';
  function cv(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function load(src) {
    return new Promise(function (ok, no) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = no; i.src = src; });
  }

  // The finished piece on a transparent canvas: steel (art + bar, name cut through, wall holes),
  // powder coat grain, lit edge. Returns {c, baseTop}.
  function piece(im, name, wall) {
    var AW = 760, mm = AW / 295, ah = Math.round(im.height * AW / im.width);
    var t = cv(AW, ah), tc = t.getContext('2d'); tc.drawImage(im, 0, 0, AW, ah);
    var px = tc.getImageData(0, 0, AW, ah).data;
    function low(x0, x1) { for (var y = ah - 1; y >= 0; y--) for (var x = x0; x < x1; x += 2) if (px[(y * AW + x) * 4 + 3] > 128) return y; return ah - 1; }
    var lo = [low(0, AW >> 1), low(AW >> 1, AW)], mn = Math.min(lo[0], lo[1]), mx = Math.max(lo[0], lo[1]);
    var PAD = 60, TOP = 20;
    var bx0 = PAD - 5 * mm, bx1 = PAD + AW + 5 * mm, by = TOP + mn - 3 * mm, bh = (wall ? 30 : 20) * mm + (mx - mn) + 3 * mm;
    var gx0 = bx0 - 15 * mm, gx1 = bx1 + 15 * mm, gy = by + bh - 3 * mm, gh = 3 * mm;
    var W = AW + 2 * PAD, H = wall ? by + bh + 4 : gy + gh + 4;
    var L = cv(W, H), l = L.getContext('2d');
    l.drawImage(t, PAD, TOP);
    l.fillStyle = '#000'; l.fillRect(bx0, by, bx1 - bx0, bh);
    var fs = 11 * mm / 0.7;
    l.font = '700 ' + fs + 'px ' + FONT;
    while (l.measureText(name).width > (bx1 - bx0) * 0.8 && fs > 8) { fs *= 0.92; l.font = '700 ' + fs + 'px ' + FONT; }
    l.globalCompositeOperation = 'destination-out';
    l.textAlign = 'center'; l.textBaseline = 'alphabetic';
    if (name) l.fillText(name, (bx0 + bx1) / 2, by + (bh - (wall ? 0 : 3 * mm)) / 2 + fs * 0.35);
    if (wall) [0.15, 0.85].forEach(function (f) { l.beginPath(); l.arc(bx0 + f * (bx1 - bx0), by + 6 * mm, 2.5 * mm, 0, 7); l.fill(); });
    var C = cv(W, H), c = C.getContext('2d');
    // matte black powder coat: fine grain, a soft top-to-bottom falloff, then a lit top-left edge
    var N = cv(64, 64), n = N.getContext('2d'), d = n.createImageData(64, 64);
    for (var i = 0; i < d.data.length; i += 4) { var v = 26 + Math.random() * 14; d.data[i] = d.data[i + 1] = v; d.data[i + 2] = v * 1.04; d.data[i + 3] = 255; }
    n.putImageData(d, 0, 0);
    c.fillStyle = c.createPattern(N, 'repeat'); c.fillRect(0, 0, W, H);
    var sh = c.createLinearGradient(0, 0, W, H); sh.addColorStop(0, 'rgba(255,255,255,.07)'); sh.addColorStop(1, 'rgba(0,0,0,.18)');
    c.fillStyle = sh; c.fillRect(0, 0, W, H);
    c.globalCompositeOperation = 'destination-in'; c.drawImage(L, 0, 0);
    c.globalCompositeOperation = 'source-over';
    var E = cv(W, H), e = E.getContext('2d');
    e.drawImage(L, 0, 0); e.globalCompositeOperation = 'source-in'; e.fillStyle = '#9a9aa0'; e.fillRect(0, 0, W, H);
    e.globalCompositeOperation = 'destination-out'; e.drawImage(L, 2, 2);
    c.globalAlpha = 0.7; c.drawImage(E, 0, 0); c.globalAlpha = 1;
    if (wall) return { c: C, foot: H - 4 };
    return { c: C, foot: gy + gh, x0: bx0, x1: bx1 };
  }

  // Crop to the painted pixels so the plate's w means the real outer width.
  function trim(p) {
    var c = p.c, x = c.getContext('2d'), d = x.getImageData(0, 0, c.width, c.height).data, x0 = c.width, x1 = 0, y0 = c.height, y1 = 0;
    for (var y = 0; y < c.height; y += 2) for (var i = 0; i < c.width; i += 2) if (d[(y * c.width + i) * 4 + 3] > 20) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    var o = cv(x1 - x0 + 2, p.foot - y0); o.getContext('2d').drawImage(c, -x0, -y0);
    return o;
  }

  function place(plate, P, cfg) {
    var S = cv(plate.width, plate.height), s = S.getContext('2d');
    s.drawImage(plate, 0, 0);
    var k = plate.width / 1024, w = cfg.w * k, h = P.height * w / P.width, x = cfg.cx * k - w / 2, y = cfg.y * k - h;
    // silhouette for shadows
    var Sh = cv(P.width, P.height), sc = Sh.getContext('2d');
    sc.drawImage(P, 0, 0); sc.globalCompositeOperation = 'source-in'; sc.fillStyle = '#1a140f'; sc.fillRect(0, 0, P.width, P.height);
    if (cfg.mount === 'wall') {
      // on 10 mm stand-offs: a soft offset shadow on the wall, away from the light
      s.save(); s.filter = 'blur(' + (7 * k) + 'px)'; s.globalAlpha = 0.5;
      s.drawImage(Sh, x - cfg.lx * 14 * k, y + 16 * k, w, h); s.restore();
      s.save(); s.filter = 'blur(' + (2 * k) + 'px)'; s.globalAlpha = 0.35;
      s.drawImage(Sh, x - cfg.lx * 4 * k, y + 5 * k, w, h); s.restore();
    } else {
      // standing on the desk: contact shadow under the base, and a faint cast shadow behind
      s.save(); s.filter = 'blur(' + (10 * k) + 'px)'; s.globalAlpha = 0.28;
      s.drawImage(Sh, x - cfg.lx * 22 * k, y - 6 * k, w, h); s.restore();
      s.save(); s.filter = 'blur(' + (5 * k) + 'px)'; s.fillStyle = 'rgba(25,18,12,.55)';
      s.beginPath(); s.ellipse(x + w / 2 - cfg.lx * 6 * k, y + h - 1 * k, w * 0.5, 7 * k, 0, 0, 7); s.fill(); s.restore();
    }
    s.drawImage(P, x, y, w, h);
    // the room's light: warm cast, brighter on the lit side
    var lit = cv(w, h), lc = lit.getContext('2d');
    lc.drawImage(P, 0, 0, w, h); lc.globalCompositeOperation = 'source-atop';
    var g = lc.createLinearGradient(cfg.lx < 0 ? 0 : w, 0, cfg.lx < 0 ? w : 0, 0);
    g.addColorStop(0, 'rgba(255,214,170,' + (0.10 + cfg.warm) + ')'); g.addColorStop(1, 'rgba(0,0,0,.12)');
    lc.fillStyle = g; lc.fillRect(0, 0, w, h);
    s.globalCompositeOperation = 'soft-light'; s.drawImage(lit, x, y); s.globalCompositeOperation = 'source-over';
    return S;
  }

  var cache = {};
  window.mlSteelScenePlates = PLATES;
  window.mlSteelScenes = function (stencilUrl, name, cb, opts) {
    opts = opts || {};
    var base = opts.base || '', size = opts.size || 1024, key = stencilUrl + '|' + name + '|' + size;
    if (cache[key]) return cb(cache[key]);
    var fonts = document.fonts && document.fonts.load ? document.fonts.load('700 40px Barlow').catch(function () {}) : Promise.resolve();
    var plates = (opts.only ? PLATES.filter(function (p) { return opts.only.indexOf(p.key) >= 0; }) : PLATES);
    Promise.all([load(stencilUrl), fonts].concat(plates.map(function (p) { return load(base + p.file); }))).then(function (r) {
      var im = r[0], out = [], pieces = { desk: trim(piece(im, name, false)), wall: trim(piece(im, name, true)) };
      plates.forEach(function (p, i) {
        var pl = r[i + 2], S = place(pl, pieces[p.mount], p);
        if (size !== pl.width) { var z = cv(size, size); z.getContext('2d').drawImage(S, 0, 0, size, size); S = z; }
        out.push({ key: p.key, mount: p.mount, label: p.label, src: S.toDataURL('image/jpeg', 0.88) });
      });
      cache[key] = out; cb(out);
    }).catch(function () { cb([]); });
  };
})();
